export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind, Message} from 'kpc';
import type {SenderAttachment, UploadButtonSlotParams} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
    dialogVisible?: boolean
    mode?: 'file' | 'url'
    url?: string
}

export default class extends Component<Props> {
    static template = template;

    private uploadScope: UploadButtonSlotParams | null = null;
    private fileInput: HTMLInputElement | null = null;

    static defaults() {
        return {
            value: '',
            attachments: [],
            dialogVisible: false,
            mode: 'file' as const,
            url: '',
        };
    }

    getUploadProps() {
        return {
            accept: 'image/*,.pdf,.doc,.docx',
            limit: 6,
        };
    }

    @bind
    openDialog(scope: UploadButtonSlotParams) {
        this.uploadScope = scope;
        this.set('dialogVisible', true);
    }

    @bind
    confirmAttachment() {
        if (this.get('mode') === 'file') {
            const files = this.fileInput?.files;
            if (!files || files.length === 0) {
                Message.warning('请选择文件');
                return false;
            }
            this.set('dialogVisible', false);
            this.uploadScope?.addFiles(files);
        } else {
            const url = (this.get('url') || '').trim();
            if (!url) {
                Message.warning('请输入 URL');
                return false;
            }
            const attachments = this.get('attachments') || [];
            const name = this.getAttachmentName(url);
            this.set({
                attachments: attachments.concat({
                    key: url,
                    uid: url,
                    name,
                    type: 'image',
                    src: url,
                    status: 'done' as const,
                }),
                url: '',
                dialogVisible: false,
            });
        }
        return true;
    }

    getAttachmentName(url: string) {
        try {
            const parsed = new URL(url);
            const last = parsed.pathname.split('/').filter(Boolean).pop() || 'url-image.jpg';
            if (/\.[a-z0-9]+$/i.test(last)) return decodeURIComponent(last);
            return decodeURIComponent(last) + '.jpg';
        } catch (_e) {
            const fallback = url.split('/').pop() || 'url-image.jpg';
            if (/\.[a-z0-9]+$/i.test(fallback)) return fallback;
            return fallback + '.jpg';
        }
    }
}